import type { UserRole } from '@/types';

const ROLE_HIERARCHY: Record<UserRole, UserRole[]> = {
  ADMIN: ['ADMIN', 'MANAGER', 'OFFICER', 'COLLECTOR', 'VIEWER'],
  MANAGER: ['MANAGER', 'OFFICER', 'COLLECTOR', 'VIEWER'],
  OFFICER: ['OFFICER', 'MANAGER', 'COLLECTOR', 'VIEWER'],
  COLLECTOR: ['COLLECTOR', 'VIEWER'],
  VIEWER: ['VIEWER'],
};

export function hasRoleAccess(
  currentRole: UserRole | string | undefined,
  allowedRoles: UserRole[],
): boolean {
  if (!currentRole) {
    return false;
  }

  const effectiveRoles = ROLE_HIERARCHY[currentRole as UserRole] || [currentRole as UserRole];
  return allowedRoles.some(role => effectiveRoles.includes(role));
}
